export const useNotifications = () => {
  // useState (not ref()) so every caller shares the same list — otherwise
  // each call site gets its own private array and its notifications never
  // reach the panel/toast UI, which reads the instance created in the
  // dashboard layout.
  const notifications = useState('app-notifications', () => [])
  const hasUnread = computed(() => notifications.value.some(n => !n.read))
  const unreadCount = computed(() => notifications.value.filter(n => !n.read).length)

  // Add a manual notification (like from keyboard shortcut).
  // options.action     { label, kind, ...payload } — a button on the toast;
  //                    the layout routes it by `kind`
  // options.persistent the toast stays until closed (it carries an action)
  // options.toast      false = panel only, no toast
  // options.tone       'critical' = failure styling
  const addNotification = (title, description, url, type = 'manual', options = {}) => {
    const newNotification = {
      // Two notifications in the same millisecond must not share an id: the
      // layout toasts each id once.
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      title,
      description,
      timestamp: new Date(),
      read: false,
      url,
      type,
      action: options.action || null,
      persistent: !!options.persistent,
      toast: options.toast !== false,
      tone: options.tone || null,
    }
    
    notifications.value.unshift(newNotification)
    
    // Auto-remove after 5 seconds for toast display (only for manual notifications)
    if (type === 'manual') {
      setTimeout(() => {
        removeNotification(newNotification.id)
      }, 5000)
    }
    
    return newNotification
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const markAsRead = (id) => {
    const notification = notifications.value.find(n => n.id === id)
    if (notification) {
      notification.read = true
    }
  }

  const markAllAsRead = () => {
    notifications.value.forEach(n => n.read = true)
  }

  const clearAll = () => {
    notifications.value = []
  }

  return {
    notifications: readonly(notifications),
    hasUnread,
    unreadCount,
    addNotification,
    removeNotification,
    markAsRead,
    markAllAsRead,
    clearAll
  }
}